import axios from 'axios';

const store = {};

const state = {
    countryList: [],
    countryMapNameIso3: {},
    countryMapIso3Name: {},
    countryListLoading: false,
    countryListLoaded: false,
};

const mutations = {
    SET_COUNTRY_LIST(state, { list, mapNameIso3, mapIso3Name }) {
        state.countryList = list;
        state.countryMapNameIso3 = mapNameIso3;
        state.countryMapIso3Name = mapIso3Name;
        state.countryListLoaded = true;
        state.countryListLoading = false;
    },
    SET_COUNTRY_LOADING(state, isLoading) {
        state.countryListLoading = isLoading;
    }
};

const getters = {
    countryList: (state) => state.countryList,
    countryMapNameIso3: (state) => state.countryMapNameIso3,
    countryMapIso3Name: (state) => state.countryMapIso3Name,
    isCountryListLoaded: (state) => state.countryListLoaded,
};

function canonName(s) {
    try {
        return String(s || '')
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase()
            .trim();
    } catch {
        return String(s || '').toLowerCase().trim();
    }
}

const actions = {
    loadCountryList({ commit, state }) {
        if (state.countryListLoaded || state.countryListLoading) return Promise.resolve();

        commit('SET_COUNTRY_LOADING', true);
        const url = 'WebApi.asmx/api/CountryService/GetCountryList';
        
        return axios.get(url)
            .then(res => {
                const list = res?.data?.countryList || [];
                const mapNameIso3 = {};
                const mapIso3Name = {};
                
                if (Array.isArray(list)) {
                    for (const it of list) {
                        const name = canonName(it?.CouName || '');
                        const iso3 = String(it?.CouIso3 || '').toUpperCase();
                        if (name && iso3 && iso3 !== 'NULL' && iso3 !== '-99') {
                            mapNameIso3[name] = iso3;
                            mapIso3Name[iso3] = it?.CouName || iso3;
                        }
                    }
                }
                
                commit('SET_COUNTRY_LIST', { list, mapNameIso3, mapIso3Name });
                return res;
            })
            .catch(e => {
                console.error('Failed to load country list', e);
                commit('SET_COUNTRY_LOADING', false);
            });
    }
};

export default {
    state,
    store,
    mutations,
    getters,
    actions
};
